import Highcharts from 'highcharts/highstock';
import highchartsMore from 'highcharts/highcharts-more';
import solidGauge from 'highcharts/modules/solid-gauge';
import highchartsNoDataDisplay from 'highcharts/modules/no-data-to-display';
import momentTz from 'moment-timezone';
import { DATE_FORMATS, dateWithTimezone } from './dateTime';
import { highchartsOptionsSetter } from './highchartsOptionsSetter';

// @ts-ignore
window.moment = momentTz;
highchartsMore(Highcharts);
solidGauge(Highcharts);
highchartsNoDataDisplay(Highcharts);
highchartsOptionsSetter(Highcharts);

export default Highcharts;

interface IEvent {
  trigger: string;
  min: number;
  max: number;
  rangeSelectorButton: {
    text: string;
  };
}

const getButtonValue = (event: IEvent): string | null => {
  const { trigger } = event;
  if (trigger === 'rangeSelectorInput') return 'none';
  if (trigger === 'rangeSelectorButton') return event.rangeSelectorButton.text;
  return null;
};

export const getEventChangeDateTrackingValues = (
  event: IEvent,
  timezone: string,
): { button: string | null; from: string; to: string } => ({
  button: getButtonValue(event),
  from: dateWithTimezone(timezone, event.min).format(DATE_FORMATS.UTC_DATE),
  to: dateWithTimezone(timezone, event.max).format(DATE_FORMATS.UTC_DATE),
});
